export default {
    // 顶栏
    "--topBar": '#EB5461',
    // 顶栏机构
    "--topBarAgency": '#DB4350',
    // 菜单
    "--menu": '#FFE4E7',
    // 表单边框
    "--formBorder": '#DDD4D4',
    // 培训任务大纲按钮
    "--taskNodeButton":'rgba(251, 229, 231,1)',
    "--taskContentButton":'rgba(251, 235, 197,.65)',
};